/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TutorJobs_tutor = {|
  +startedJobsCount: number;
  +openJobOffersCount: number;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TutorJobs_tutor",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "startedJobsCount",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "openJobOffersCount",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorHistory_tutor",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorPending_tutor",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorBooked_tutor",
      "args": null
    }
  ],
  "type": "Tutor"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/__generated__/TutorJobs_tutor.graphql.js